import React from 'react'
import DatePicker from "react-multi-date-picker"
import DateObject from "react-date-object";
import Icon from "react-multi-date-picker/components/icon"
const RangeDatePicker = ({style,id,...otherprops}) => {
  
    const [values, setValues] = React.useState([
        new DateObject()
      ])
     
  return (
    <>
  
  <DatePicker style={style}
 render={<Icon/>}
  value={values}
  onChange={setValues}
  range
  {...otherprops}
/>
   
  </>
  );
}

export default RangeDatePicker